/** Compatibility facade for the existing public-page hooks. No editing operations live here. */
export default class AppService {
  async getPage(page: string) {
    try {
      const response = await fetch(
        `/api/cms/pages/${encodeURIComponent(page)}/published`,
        { cache: "no-store", signal: AbortSignal.timeout(20000) }
      );
      if (response.ok) {
        const result = await response.json();
        if (
          result?.ok !== true ||
          result.value?.schemaVersion !== 1 ||
          !result.value?.content
        )
          throw new Error("Invalid published content response");
        return { data: result.value.content, error: null, isLoading: false };
      }
      // Only an explicit "not yet published" response permits the legacy read.
      // A CMS outage must not silently show old prices after publication.
      if (response.status !== 404)
        throw new Error("Published content is temporarily unavailable");
      const legacy = await fetch("/agent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          intent: "do_retrieve_json_file",
          entities: { bucket: "souledout-site", filename: `${page}.json` },
        }),
        signal: AbortSignal.timeout(20000),
      });
      const body = await legacy.json();
      if (!legacy.ok || body?.result?.success !== true || !body.result.data)
        throw new Error("Content could not be loaded");
      return { data: body.result.data, error: null, isLoading: false };
    } catch (error) {
      return { data: null, error, isLoading: false };
    }
  }
}
